export const formulaGuides = [
  {
    name: 'Mosteller',
    author: 'Robert D. Mosteller',
    year: '1987',
    equation: 'SC (m²) = √[(A (cm) × P (kg)) ÷ 3600]',
    population: 'Proposta como equação prática de uso geral, com dados antropométricos de adultos.',
    logic: 'Combina altura e peso em uma relação simples e usa uma raiz quadrada; por isso, é fácil de calcular e conferir.',
    when: 'Quando um protocolo aceita Mosteller ou quando se deseja uma estimativa simples para comparação educativa.',
    steps: 'Confirme altura em cm e peso em kg; multiplique A por P; divida por 3600; extraia a raiz quadrada e registre o resultado em m².',
    applications: 'Comparações educativas, referências de superfície corporal em adultos e contextos em que um protocolo institucional especifica Mosteller.',
    limitations: 'É uma estimativa antropométrica, não uma medição da pele. Não representa perfeitamente extremos de tamanho ou todas as formas corporais.'
  },
  {
    name: 'Du Bois e Du Bois',
    author: 'Delafield Du Bois e Eugene F. Du Bois',
    year: '1916',
    equation: 'SC (m²) = 0,007184 × P (kg)^0,425 × A (cm)^0,725',
    population: 'Equação histórica desenvolvida a partir de medidas corporais de um grupo pequeno de adultos.',
    logic: 'Eleva peso e altura a expoentes diferentes para representar que a área não cresce em proporção direta simples com cada medida.',
    when: 'Quando estudos, referências ou protocolos citam explicitamente Du Bois e Du Bois, ou para comparação com outras equações.',
    steps: 'Use P em kg e A em cm; calcule as potências indicadas; multiplique os dois termos e o coeficiente 0,007184; leia o resultado em m².',
    applications: 'Referências históricas, comparações em estudos e protocolos que nomeiam a equação; também pode aparecer em índices fisiológicos.',
    limitations: 'A amostra histórica é limitada em comparação com a diversidade atual. Não deve ser tratada como universal para crianças ou medidas extremas.'
  },
  {
    name: 'Haycock',
    author: 'George B. Haycock e colaboradores',
    year: '1978',
    equation: 'SC (m²) = 0,024265 × P (kg)^0,5378 × A (cm)^0,3964',
    population: 'Desenvolvida para abranger uma faixa ampla de tamanhos corporais, incluindo pacientes pediátricos e neonatais.',
    logic: 'Usa expoentes ajustados para relacionar peso e altura em indivíduos de tamanhos diferentes.',
    when: 'Quando o protocolo pediátrico, neonatal ou o estudo de referência especificar Haycock; não substitua automaticamente a equação indicada.',
    steps: 'Informe peso em kg e altura em cm; aplique os expoentes 0,5378 e 0,3964; multiplique os termos pelo coeficiente; registre m².',
    applications: 'Comparações em pediatria e neonatologia, pesquisas que usam a equação e contextos definidos por protocolos locais.',
    limitations: 'Mesmo uma equação desenvolvida para ampla faixa de tamanhos permanece uma aproximação; a medida e o método devem ser compatíveis com a referência.'
  },
  {
    name: 'Gehan e George',
    author: 'Edwin A. Gehan e Sarah L. George',
    year: '1970',
    equation: 'SC (m²) = 0,0235 × P (kg)^0,51456 × A (cm)^0,42246',
    population: 'Proposta a partir de dados antropométricos publicados para estimar área corporal em uma população adulta.',
    logic: 'Calcula uma combinação ponderada de peso e altura usando potências empíricas, em vez de uma proporcionalidade linear.',
    when: 'Quando uma publicação ou protocolo especifica Gehan e George, ou ao comparar estimativas em análises educativas.',
    steps: 'Converta as medidas para kg e cm; eleve cada uma ao expoente impresso; multiplique os termos entre si e pelo coeficiente 0,0235.',
    applications: 'Literatura clínica e comparações de superfície corporal; seu uso em oncologia deve seguir o protocolo específico do serviço.',
    limitations: 'A equação não incorpora diretamente idade, composição corporal ou diagnóstico. O nome da fórmula não determina sua adequação a cada paciente.'
  },
  {
    name: 'Boyd',
    author: 'Edwin Boyd',
    year: '1935',
    equation: 'SC (m²) = 0,0003207 × A (cm)^0,3 × peso (g)^[0,7285 − 0,0188 × log₁₀(peso em g)]',
    population: 'Fórmula histórica desenvolvida usando medições corporais e peso; o termo de massa é expresso em gramas.',
    logic: 'O expoente aplicado ao peso muda conforme o próprio peso. Por isso, a equação não é uma potência fixa como várias outras.',
    when: 'Quando estudos ou protocolos citarem Boyd especificamente, ou para fins de comparação metodológica.',
    steps: 'Converta peso de kg para g; calcule o expoente dependente do logaritmo decimal do peso em gramas; aplique a potência e multiplique pelos demais termos.',
    applications: 'Comparações históricas e pesquisas que necessitem reproduzir o método original com as unidades corretas.',
    limitations: 'A conversão de unidade é essencial: inserir kg no lugar de g altera radicalmente o resultado. Não extrapole sem validação para qualquer população.'
  },
  {
    name: 'Fujimoto',
    author: 'Shinichi Fujimoto e colaboradores',
    year: '1968',
    equation: 'SC (m²) = 0,008883 × P (kg)^0,444 × A (cm)^0,663',
    population: 'Associada a dados de população japonesa publicados no desenvolvimento da equação.',
    logic: 'Relaciona peso e altura com expoentes empíricos calibrados em uma população de referência específica.',
    when: 'Quando uma pesquisa ou protocolo que considera essa população nomear Fujimoto; também serve para comparação explícita entre equações.',
    steps: 'Use P em kg e A em cm; calcule P^0,444 e A^0,663; multiplique os resultados e o coeficiente 0,008883.',
    applications: 'Estudos comparativos e pesquisas com populações asiáticas quando o método escolhido pelo estudo for esta equação.',
    limitations: 'A origem populacional não garante melhor desempenho para toda pessoa de ascendência semelhante. Validação e contexto importam.'
  },
  {
    name: 'Takahira',
    author: 'Takahira',
    year: '1925',
    equation: 'SC (m²) = 0,007241 × P (kg)^0,425 × A (cm)^0,725',
    population: 'Equação histórica publicada a partir de dados de referência próprios, anterior a várias fórmulas modernas.',
    logic: 'Usa expoentes para peso e altura próximos aos de outras equações clássicas, com coeficiente específico.',
    when: 'Quando uma fonte, pesquisa ou protocolo identificar Takahira como o método requerido; não escolha apenas pelo valor resultante.',
    steps: 'Informe peso em kg e altura em cm; eleve às potências 0,425 e 0,725; multiplique ambos os termos pelo fator 0,007241.',
    applications: 'Reprodução de cálculos em literatura histórica e comparação metodológica entre estimativas.',
    limitations: 'É uma estimativa baseada em dados de referência, não uma medição universal. A equação não deve ser escolhida como substituta automática de um protocolo.'
  },
  {
    name: 'Wang',
    author: 'Y. Wang e colaboradores',
    year: '1992',
    equation: 'SC (m²) = 0,0061 × A (cm) + 0,0128 × P (kg) − 0,1529',
    population: 'Equação linear empírica publicada para estimar superfície corporal a partir de altura e peso.',
    logic: 'Multiplica cada medida por um coeficiente, soma os termos e subtrai uma constante; não usa potências.',
    when: 'Quando a pesquisa ou o protocolo especificar Wang, ou para observar como um modelo linear se compara aos modelos de potência.',
    steps: 'Confirme A em cm e P em kg; multiplique cada medida por seu coeficiente; some os resultados e subtraia 0,1529.',
    applications: 'Comparações acadêmicas e cálculos reproduzidos conforme a publicação ou protocolo que adota a equação.',
    limitations: 'Modelos lineares podem se comportar de modo diferente fora da faixa de dados que os originou. Verifique plausibilidade e escopo.'
  },
  {
    name: 'Livingston e Lee',
    author: 'Edward H. Livingston e S. Lee',
    year: '2001',
    equation: 'SC (m²) = 0,1173 × P (kg)^0,6466',
    population: 'Desenvolvida como uma estimativa baseada em peso, sem exigir altura medida.',
    logic: 'Usa apenas o peso para estimar a superfície, o que reduz a necessidade de dados, mas também elimina informação de estatura.',
    when: 'Quando a altura não está disponível e a fonte ou protocolo aceitar explicitamente um método apenas por peso.',
    steps: 'Informe o peso em kg; aplique a potência 0,6466; multiplique pelo coeficiente 0,1173; interprete o resultado como estimativa em m².',
    applications: 'Situações de comparação ou pesquisa sem altura medida, desde que a limitação seja aceita e documentada.',
    limitations: 'Pessoas com o mesmo peso e alturas diferentes recebem o mesmo resultado. Não é intercambiável com fórmulas que usam altura.'
  },
  {
    name: 'Schlich',
    author: 'Robert Schlich e colaboradores',
    year: '2010',
    equation: 'Homens: 0,000579479 × P (kg)^0,38 × A (cm)^1,24. Mulheres: 0,000975482 × P (kg)^0,46 × A (cm)^1,08.',
    population: 'Equações separadas por sexo publicadas a partir de dados antropométricos de adultos.',
    logic: 'Usa coeficientes e expoentes diferentes para cada grupo definido na publicação. A ferramenta só pergunta a variante quando Schlich é escolhido.',
    when: 'Quando o estudo ou protocolo pedir Schlich e a variante aplicável estiver definida pela fonte usada.',
    steps: 'Escolha a variante exigida; informe peso em kg e altura em cm; use o conjunto de coeficiente e expoentes correspondente; compare em m².',
    applications: 'Pesquisas ou comparações adultas que especifiquem Schlich e indiquem qual variante utilizar.',
    limitations: 'Não escolha a variante com base em suposições; siga a definição da fonte e a orientação institucional. A classificação da fórmula não substitui avaliação individual.'
  }
];
